// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuickLinks_wrapper__cah4_"};